<template>
  <transition name="modal">
    <div :class="mainClasses">
      <div class="modal__mask" @click="handleClose"></div>
      <div class="modal__wrapper">
        <div class="modal__container">
          <div class="modal__header">
            <slot name="header"></slot>
            <a href="javascript:void(0)" class="modal__close" @click="handleClose">
              <span>Close</span>
            </a>
          </div>
          <div class="modal__body">
            <slot name="body"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { wait } from '@modules/time'

export default {
  name: 'ElementModal',
  props: {
    text: {
      type: [String, Array],
      required: false
    },
    content: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  computed: {
    mainClasses () {
      return [
        'modal',
        { 'is-active': this.isActive }
      ]
    }
  },
  mounted () {
    wait(100, () => {
      this.isActive = true
    })
  },
  methods: {
    handleClose () {
      this.isActive = false
      wait(500, () => {
        this.$emit('close')
      })
    }
  }
}
</script>

<style lang="scss">
  .modal{
    @media print{
      display: none;
    }
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: 0;
    transition: opacity .3s ease;
    z-index: 98;

    &.is-active{
      .modal__mask{
        opacity: 1;
      }

      .modal__container{
        transform: scale(1)
      }
    }

    &__mask {
      @include add-transition;
      position: fixed;
      z-index: 98;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      opacity: 0;
      display: table;
    }

    &__wrapper {
      @include media("small-medium") {
        top: 5rem;
        left: 50%;
        transform: translate(-50%, 0);
      }
      @include media("large") {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      position: absolute;
      z-index: 99;
    }

    &__container {
      @include add-transition;
      @include media("small-medium") {
        width: 90vw;
        padding: layout("spacing")/2;
        border-top: 6px solid colors("modules");
      }
      @include media("large") {
        width: 50rem;
        margin-bottom: layout("spacing")*1.5;
        padding: layout("spacing");
        border-left: 6px solid colors("modules");
      }

      margin: 0px auto;
      background-color:white;
      border-radius: 6px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
      transform: scale(0);
    }

    &__close {
      @include icon(icons('cross'));
      margin-top: .3rem;
      color: black;
      font-size: 2rem;
      opacity: .2;
      transition: all .3s ease;
      @include hover{
        color: black;
        opacity: 1;
      }
      span{
        @include hide-visually();
      }
    }

    &__header {
      display: flex;
      justify-content: space-between;

      h2{
        margin-top: 0;
        font-size: 2.4rem;
        font-weight: font-weights('normal');
      }
    }

    // ANIMATION

    &-enter {
      opacity: 0;
    }

    &-leave-active {
      opacity: 0;
    }

    &-enter .modal__container,
    &-leave-active .modal__container {
      -webkit-transform: scale(1.1);
      transform: scale(1.1);
    }
  }
</style>
